import { ComponentProps, ReactNode, RefObject } from 'react';

import * as navigationStore from '../stores/navigationStore';

type AnchorProps = ComponentProps<'a'> & {
  children: ReactNode;
  ref?: RefObject<HTMLAnchorElement>;
};

export default function Link({
  children,
  className,
  href,
  onClick,
  ref,
  ...rest
}: AnchorProps) {
  const path = href?.split('?')[0];
  const isInternal = path?.startsWith('/');

  if (!isInternal) {
    return (
      <a
        href={href}
        rel="noreferrer noopener"
        ref={ref}
        onClick={onClick}
        className={className}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <a
      href={href}
      onClick={(e) => {
        e.preventDefault();
        if (href) navigationStore.navigate(href);
        onClick?.(e);
      }}
      className={className}
      ref={ref}
      {...rest}
    >
      {children}
    </a>
  );
}
